import { Box, Button, styled } from "@material-ui/core";
import {
  EPOCUS_STATUS_DRAFT_BG,
  EPOCUS_STATUS_DRAFT_TEXT,
  rem,
} from "../../../_lib/epocus-palette";

const Banner = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  padding: "8px 12px",
  backgroundColor: EPOCUS_STATUS_DRAFT_BG,
  color: EPOCUS_STATUS_DRAFT_TEXT,
  fontSize: rem(13),
});

const RetryButton = styled(Button)({
  minHeight: 44,
  textTransform: "none",
  fontWeight: 700,
  color: EPOCUS_STATUS_DRAFT_TEXT,
});

export const ConnectionBanner: FC<{
  error?: Error;
  onRetry: () => void;
}> = ({ error, onRetry }) => {
  if (!error) return null;

  return (
    <Banner role="status" aria-live="polite">
      <span>The connection dropped. Nothing you have done has been lost.</span>
      <RetryButton size="small" onClick={onRetry}>
        Pick up where we left off
      </RetryButton>
    </Banner>
  );
};
